import {currentCartV2} from '@wix/ecom';
import {ModelContext} from '../../../types/app.types';

export enum UpsellFetchStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  LOADED = 'loaded',
}

export class UpsellOptionModel {
  public id: string;
  public title?: string | null;
  public description?: string | null;
  public catalogReference: currentCartV2.CatalogReference;
  public formattedPrice?: string;
  public price?: string | null;
  public priceDescription?: string | null;
  public benefitType?: string | null;
  public benefitValue?: string | null;

  constructor(params: UpsellOptionModel) {
    this.id = params.id;
    this.title = params.title;
    this.description = params.description;
    this.catalogReference = params.catalogReference;
    this.formattedPrice = params.formattedPrice;
    this.price = params.price;
    this.priceDescription = params.priceDescription;
    this.benefitType = params.benefitType;
    this.benefitValue = params.benefitValue;
  }

  public static fromCartV2(
    upsellOption: currentCartV2.UpsellOption,
    modelContext: ModelContext,
    isPriceInDisplayCurrency: boolean
  ): UpsellOptionModel {
    const {priceDetails, metadata} = upsellOption;
    return new UpsellOptionModel({
      id: upsellOption._id,
      title: upsellOption.title,
      description: upsellOption.description,
      catalogReference: upsellOption.catalogReference,
      formattedPrice:
        isPriceInDisplayCurrency && priceDetails?.price ? modelContext.formatAmount(priceDetails.price) : undefined,
      price: priceDetails?.price,
      priceDescription: priceDetails?.description,
      benefitType: metadata?.benefitType,
      benefitValue: metadata?.benefitValue,
    });
  }
}
